import { RequestHelper } from '@/helpers';

export default {
    isNewApplyBtn() {
        return RequestHelper.getQueryVariable('test') === 'new-apply-btn';
    }
}